import React, { useEffect } from "react";
import Navbar from "../Navigation/Navigation";
import Footer from "../Footer/Footer";
import RelatedWorks from "./RelatedWorks";
import "./WorkDetail.css";

export default function GangaSweetsDetails() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="work-detail-page">
      <div style={{ position: 'absolute', top: 0, left: 0, width: '100%', zIndex: 1000 }}>
        <Navbar />
      </div>

      <section className="project-info-section">
        <h1 className="project-title-heading">
          Ganga Sweets
        </h1>

        <p className="project-description">
          A complete packaging and print branding project for Ganga Sweets, featuring sweet box packaging, carry bags, visiting cards, and brand collateral designed to elevate the customer experience        </p>

        <div className="project-tags">
          <span className="info-tag">Brand Identity</span>
          <span className="info-tag">Print Collateral</span>
          <span className="info-tag">Packaging Design</span>
          <span className="info-tag">Business Stationery</span>
        </div>
      </section>

      {/* Full landscape video */}
      <div className="project-full-image-section">
        <img src="https://ascentbw.com/Images/Gangasweets/Full1.webp" alt="Ganga Sweets Store Branding" />
      </div>

      {/* Two portrait images in a row left and right */}
      <div className="project-full-image-section">
        <img src="https://ascentbw.com/Images/Gangasweets/Full2.webp" alt="Ganga Sweets Store Branding" />
      </div>

      {/* Quote text below the portrait images */}
      <section className="project-quote-section">
        <div className="quote-text right-aligned">
          "We created distinctive packaging and bag designs for Ganga Sweets, blending vibrant visuals, traditional influences, and functional design. The result is a memorable brand experience that elevates product presentation while maintaining consistency across retail and takeaway interactions."        </div>
      </section>

      {/* Additional full landscape section */}
      <div className="project-full-image-section">
        <img src="https://ascentbw.com/Images/Gangasweets/Full3.webp" alt="Ganga Sweets Store Branding" />
      </div>

      <div className="project-full-image-section">
        <img src="https://ascentbw.com/Images/Gangasweets/Full4.webp" alt="Ganga Sweets Store Branding" />
      </div>

      <section className="project-quote-section">
        <div className="quote-text right-aligned">
          "We created distinctive packaging designs and managed the print production process for Ganga Sweets, ensuring every package reflected the brand's tradition, quality, and craftsmanship. The result is a cohesive packaging system that elevates shelf presence and reinforces the brand's identity across customer touchpoints."
        </div>
      </section>

      <div className="project-full-image-section">
        <img src="https://ascentbw.com/Images/Gangasweets/Full5.webp" alt="Ganga Sweets Store Branding" />
      </div>

      <section className="project-quote-section">
        <div className="quote-text right-aligned">
          "We created premium visiting cards and managed print production for Ganga Sweets, delivering a refined brand touchpoint that reflects the company's heritage, professionalism, and commitment to quality."
        </div>
      </section>



      <RelatedWorks excludePath="/works/gangasweets" />
      <Footer />
    </div>
  );
}
